import { http, HttpResponse } from 'msw';
import { PlessService } from '../../../app/shared/pless-service.model';
import { ResponseUtils } from '../response-utils';

export const kymw9005Handlers = [
    // KYMW9005ユーザ情報設定
	http.post(
		PlessService.SERVICE.getAssociatedUserManagementDetail.url,
		async ({ request }) => {
			const req = await request.json();
			return HttpResponse.json(getAssociatedUserManagementDetail);
		}
	),
	http.post(
		PlessService.SERVICE.registAssociatedUserManagement.url,
		async ({ request }) => {
			const req = await request.json();
			return HttpResponse.json(registAssociatedUserManagement);
		}
	),
	http.post(
		PlessService.SERVICE.updateAssociatedUserManagement.url,
		async ({ request }) => {
			const req = await request.json();
			return HttpResponse.json(updateAssociatedUserManagement);
		}
	),
];

const getAssociatedUserManagementDetail = {
  status: "ok",
  message: "処理終了",
  result: {
    obj: {
      AssociatedUserId: "00000001",
      AssociatedUserType: "1",
      AssociatedUserName: "取引太郎",
      AssociatedUserNameKana: "とりひきたろう",
      EmailAddress: "torihiki.tarou@xxx.co.jp",
      AuthoritySetId: "01",
      AuthoritySetName: "一般ユーザ",
      AssociatedCompanyId: "000001",
      AssociatedCompanyName: "関連会社名",
      IsEnabled: "0",
    }
  }
}

const registAssociatedUserManagement = {
  status: "ok",
  message: "処理完了",
  result: {
    obj: {
      AssociatedUserId: "1",
    }
  }
}

const updateAssociatedUserManagement = {
  status: "ok",
  message: "処理完了"
}